import { ScheduleToleranceConfig, ScheduleToleranceSource } from '@mi-front/core';
import { Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

import { FormattedMessage } from 'react-intl';
export function ScheduleTolerance(p: { config: ScheduleToleranceConfig }) {
  if (!p.config) {
    return null;
  }

  const inheritedIndicator = (
    <Tooltip
      title={
        <FormattedMessage
          id="audit.schedulesListScreen.inheritedTolerance"
          defaultMessage="Heredada de config de cliente"
        />
      }
    >
      <span className="d-inline-block mx-1 text-muted">
        <WarningIcon sx={{ fontSize: 'inherit' }} />
      </span>
    </Tooltip>
  );

  const before = (
    <>
      {p.config.before.value}
      {p.config.before.source === ScheduleToleranceSource.INHERITED_FROM_CLIENT_CONFIG &&
        inheritedIndicator}
    </>
  );

  const after = (
    <>
      {p.config.after.value}
      {p.config.after.source === ScheduleToleranceSource.INHERITED_FROM_CLIENT_CONFIG &&
        inheritedIndicator}
    </>
  );

  return (
    <>
      {before} / {after}
    </>
  );
}
